<!--
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2024-01-26 11:34:38
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2024-02-19 13:40:03
-->
<script lang='ts' setup>
import { APP_ROUTER, checkLink, imageTransform } from '@qctsw/common'
import topicSwiper from '../components/swiper.vue'

import gridImage from '../components/gridImage.vue'
import topicCard from '../components/topicCard.vue'
import tabPageData from '../components/tabPageData.vue'
import otherArticleVue from '../components/otherArticle.vue'
import { LOAD_STATE } from '~/shared/types'
import type { LocationShowCodeEnum, OtherArticle, PastTopic, TemplateTypeCode, TopicArticleBase, TopicTemplateNewsItem } from '~/server/types'
import { topicBaseDetailApi, topicTemplateBaseDataApi, topicTemplatePageDataApi } from '@/server'

const props = defineProps<{ topicId: string, templateTypeCode: TemplateTypeCode, bodyJson: Record<string, any> }>()

const topicData = reactive<{

  pastTopics: PastTopic[]
  otherArticle: OtherArticle[]
  newReport: TopicArticleBase[]
  knowledgeExtend: TopicArticleBase[]
}>({

  pastTopics: [],
  otherArticle: [],
  newReport: [],
  knowledgeExtend: [],
})

async function getData() {
  const loadState = ref(LOAD_STATE.INIT)
  const res = await useLoadState({
    key: 'topicTemplateBaseDataApi',
    state: loadState,
    fn: () => topicTemplateBaseDataApi({
      topicId: props.topicId,
      templateTypeCode: props.templateTypeCode as 1,
    }),
  })
  const baseData = res?.data || {}
  // console.log('🚀 ~ getData ~ res:', res)
  topicData.pastTopics = baseData.pastTopics
  topicData.newReport = baseData.newReport
  topicData.knowledgeExtend = baseData.knowledgeExtend
}
await getData()
onMounted(async () => {

})
</script>

<template>
  <div class="box flex flex-col w-full pb-10 items-center">
    <div class="w-full">
      <img w-full :src="imageTransform(bodyJson?.div_0?.topCoverImg, {})">
    </div>
    <div w-1200px mt-3>
      <topicSwiper :topic-id="topicId" />

      <div class="flex w-full my-2">
        <div class="list  w-[calc(100%-380px)] pr-10">
          <tabPageData :template-type-code="1" :topic-id="topicId" :tab-list="(bodyJson?.div_1 || [])" />
        </div>
        <div w-380px overflow-hidden>
          <topicCard default-class="title_line" :title="bodyJson?.div_2?.title || '最新报道'">
            <gridImage :to-page="APP_ROUTER.newsDetail" :cols="2" :list="topicData.newReport" />
          </topicCard>
          <topicCard default-class="title_line" :title="bodyJson?.div_3?.title || '知识拓展'">
            <otherArticleVue :list="topicData.knowledgeExtend" />
          </topicCard>
        </div>
      </div>
      <div>
        <topicCard default-class="title_line" :title="bodyJson?.div_4?.title || '推荐专题'">
          <gridImage :to-page="APP_ROUTER.topicDetail" :cols="4" :list="topicData.pastTopics" />
        </topicCard>
      </div>
    </div>
  </div>
</template>

<style lang='scss' scoped>
.box{
  background-color: var(--bodyBg);
}
</style>
